import { render, staticRenderFns } from "./IdentifyFace.vue?vue&type=template&id=f91a1814"
import script from "./IdentifyFace.vue?vue&type=script&lang=js"
export * from "./IdentifyFace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports